export enum PostMessageEvent {
    PARTNER_CONFIG_REQUESTED = 'partnerConfigRequested',
    PARTNER_CONFIG_SENT = 'partnerConfigSent',
}

export class PostMessage {
    event: PostMessageEvent;
    payload?: any;
}
